import React, { useState, useEffect } from 'react'
import { supabase } from './supabase'

function Lists() {
  const [lists, setLists] = useState([])
  const [activeList, setActiveList] = useState(null)
  const [items, setItems] = useState([])
  const [newListName, setNewListName] = useState('')
  const [newItemText, setNewItemText] = useState('')

  useEffect(() => {
    fetchLists()
  }, [])

  useEffect(() => {
    if (activeList) fetchItems(activeList.id)
  }, [activeList])

  async function fetchLists() {
    const { data, error } = await supabase
      .from('lists')
      .select('*')
      .order('created_at', { ascending: false })
    if (!error) setLists(data)
  }

  async function addList() {
    if (!newListName.trim()) return
    const { error } = await supabase
      .from('lists')
      .insert([{ name: newListName }])
    if (!error) {
      setNewListName('')
      fetchLists()
    }
  }

  async function fetchItems(listId) {
    const { data, error } = await supabase
      .from('list_items')
      .select('*')
      .eq('list_id', listId)
      .order('created_at', { ascending: true })
    if (!error) setItems(data)
  }

  async function addItem() {
    if (!newItemText.trim() || !activeList) return
    const { error } = await supabase
      .from('list_items')
      .insert([{ list_id: activeList.id, text: newItemText, completed: false }])
    if (!error) {
      setNewItemText('')
      fetchItems(activeList.id)
    }
  }

  async function toggleItem(item) {
    const { error } = await supabase
      .from('list_items')
      .update({ completed: !item.completed })
      .eq('id', item.id)
    if (!error) fetchItems(activeList.id)
  }

  async function deleteItem(itemId) {
    const { error } = await supabase
      .from('list_items')
      .delete()
      .eq('id', itemId)
    if (!error) fetchItems(activeList.id)
  }

  async function deleteList(listId) {
    await supabase.from('list_items').delete().eq('list_id', listId)
    await supabase.from('lists').delete().eq('id', listId)
    setActiveList(null)
    setItems([])
    fetchLists()
  }

  return (
    <div className="lists-container">
      <div className="lists-sidebar">
        <h2>Our Lists</h2>
        <div className="new-list-form">
          <input
            placeholder="New list name..."
            value={newListName}
            onChange={e => setNewListName(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && addList()}
          />
          <button onClick={addList}>Add</button>
        </div>
        <div className="lists-menu">
          {lists.map(list => (
            <div
              key={list.id}
              className={`list-item ${activeList?.id === list.id ? 'active' : ''}`}
              onClick={() => setActiveList(list)}
            >
              <span>{list.name}</span>
              <button className="delete-list-btn" onClick={e => { e.stopPropagation(); deleteList(list.id) }}>×</button>
            </div>
          ))}
        </div>
      </div>

      <div className="list-content">
        {!activeList ? (
          <div className="list-empty">
            <p>Select a list or create a new one.</p>
          </div>
        ) : (
          <div>
            <h2>{activeList.name}</h2>
            <div className="new-item-form">
              <input
                placeholder="Add an item..."
                value={newItemText}
                onChange={e => setNewItemText(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && addItem()}
              />
              <button onClick={addItem}>Add</button>
            </div>
            <div className="items-list">
              {items.map(item => (
                <div key={item.id} className={`list-entry ${item.completed ? 'completed' : ''}`}>
                  <input
                    type="checkbox"
                    checked={item.completed}
                    onChange={() => toggleItem(item)}
                  />
                  <span>{item.text}</span>
                  <button className="delete-item-btn" onClick={() => deleteItem(item.id)}>×</button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Lists